// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrentContestSection_container__4TZVE","containerWhite":"CurrentContestSection_containerWhite__P_Jzs"};